var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStaticFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.975 0C8.72933 0 0.5 8.10443 0.5 16.2089C0.5 21.6118 3.74177 27.9216 9.87084 30.2565V41L21.7301 32.7918C33.6271 32.4966 41.0222 24.8536 41.0222 16.2089C41.0222 8.64473 33.2207 0 20.975 0ZM22.561 29.5425H20.9402L12.8357 35.4858V27.9216C12.8357 27.9216 11.579 27.9216 10.6745 27.3813C6.44325 24.8536 3.74177 20.8337 3.74177 16.2089C3.74177 9.42541 11.1441 3.06805 20.9402 3.06805C30.7363 3.06805 37.7804 9.42541 37.7804 16.2089C37.7804 22.9923 32.3571 29.5425 22.561 29.5425Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1154 15.2437H16.2692C16.2692 16.4983 16.7676 17.7016 17.6548 18.5888C18.542 19.476 19.7453 19.9744 21 19.9744C22.2547 19.9744 23.458 19.476 24.3452 18.5888C25.2324 17.7016 25.7308 16.4983 25.7308 15.2437H28.8846C28.8846 17.3348 28.0539 19.3403 26.5753 20.8189C25.0966 22.2976 23.0911 23.1283 21 23.1283C18.9089 23.1283 16.9034 22.2976 15.4247 20.8189C13.9461 19.3403 13.1154 17.3348 13.1154 15.2437Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticFeedback);
export default __webpack_public_path__ + "static/media/static-feedback.578a6a75.svg";
export { ForwardRef as ReactComponent };